/** Voice / assistant feature gate. Default on; set `REACT_APP_VOICE_ASSISTANT=false` to hide. */
export function isVoiceAssistantEnabled(): boolean {
  const raw = process.env.REACT_APP_VOICE_ASSISTANT?.trim().toLowerCase();
  if (raw === 'false' || raw === '0' || raw === 'off' || raw === 'no') {
    return false;
  }
  if (raw === 'true' || raw === '1' || raw === 'on' || raw === 'yes') {
    return true;
  }
  return true;
}
